// Общие модули сайта

import initForms from './Forms/index';
import initLazyImage from './LazyImage/index';
import initLightbox from './Lightbox/index';
import initMainMenu from './MainMenu/index';
import initOnlineOffice from './OnlineOffice/index';
import initRuTarget from './RuTarget/index';
import {initVideoContainer} from './Video/index';
import {initCompilation} from './Compilation/index';
import {saveUTMTags} from './UTMTags';

/**
 * Общие модули сайта
 */
function main(): void
{
	initMainMenu();
	initForms();
	initLazyImage();
	initLightbox();
	initOnlineOffice();
	initRuTarget();
	initCompilation();
	initVideoContainer();
	saveUTMTags();
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/index.ts